$(function() {
	// -------------------------------------------
	// 共通関数定義
	// -------------------------------------------
	if (!window.Nifty || !window.Nifty.Utils || !window.Nifty.WallPaint || !window.Nifty.Data) {
		return;
	}
	window.Nifty.WallPaint.Pc = window.Nifty.WallPaint.Pc || {};

	// 共通: animation再設定
	Nifty.WallPaint.Pc.Animation = {
		setAccordion: function() {
			if (typeof HandyCollapse == 'function') {
				new HandyCollapse({
					nameSpace: "accordion",
					closeOthers: false
				});
			}
		}
		,initMicroModal: function() {
			if (typeof MicroModal == 'object') {
				MicroModal.init({
					awaitCloseAnimation: true
				});
			}
		}
		,setCheckMatch: function() {
			if (typeof CheckMatch == 'function') {
				new CheckMatch({
					nameSpace: "checkmatch"
				});
				$('input[data-checkmatch-all]:not(:checked)').each(function() {
					const $checkItems = $('input[data-checkmatch-group="' + $(this).attr('data-checkmatch-all') + '"]');
					if ($checkItems.length > 0 && $checkItems.filter(':not(:checked)').length <= 0) {
						$(this).prop('checked', true);
					}
				});
			}
		}
		,initFormLock: function() {
			// FormLockの初期状態設定が正しく動作しない為、実装
			$('[data-formlock-seal]').each(function() {
				const control = $(this).attr('data-formlock-seal');
				if ($('input[data-formlock-control="' + control + '"]:checked').length > 0) {
					$(this).removeClass('is-disabled').removeAttr('disabled');
					$('[data-formlock-content="' + control + '"].is-formlock-mask').addClass('is-active');
				} else {
					$('[data-formlock-content="' + control + '"].is-formlock-mask').removeClass('is-active');
				}
			});
		}
		,setFormLock: function() {
			if (typeof FormLock == 'function') {
				new FormLock({
					nameSpace: "formlock"
				});
				this.initFormLock();
			}
		}
		,setReadmore: function() {
			if (typeof Readmore == 'function' && typeof readmore == 'object') {
				$('[data-readmore-content]').removeClass('is-ellipsis-enabled');
				$('[data-readmore-control]').removeClass('is-disabled');
				readmore.setContent();
			}
		}
	};
	if (typeof scroll == 'object') {
		// animation.min.jsで適用されるSmoothScrollが余計なので削除
		scroll.destroy();
	}
	Nifty.WallPaint.Pc.Animation.initFormLock();
	Nifty.WallPaint.Pc.Animation.setReadmore();

	// 共通: PC共通関数
	Nifty.WallPaint.Pc.Function = {
		// 共通: Loading表示/非表示
		setShowLoading: function(isShow) {
			Nifty.WallPaint.Function.setShowLoading(isShow);
		}
		// 都道府県, 検索結果: 検索条件パーツ生成(市区町村、路線/駅)
		,_$searchConditionStation: $('[data-template="search-condition-station"]')
		,_$searchConditionStationBase: $('[data-template-base="search-condition-station"]')
		,_$searchConditionCity: $('[data-template="search-condition-city"]')
		,_$searchConditionCityBase: $('[data-template-base="search-condition-city"]')
		,_$searchConditionLine: $('[data-template="search-condition-line"]')
		,_$searchConditionLineBase: $('[data-template-base="search-condition-line"]')
		,_$changeAreasConditionTrigger: $('[data-change-areas-condition-trigger]')
		,_isSearchConditionPlacesHtmlDone: false
		,initChangeAreasConditionTrigger: function() {
			// HTML生成完了まで、エリア条件選択の起動ボタンを無効化
			this._$changeAreasConditionTrigger.addClass('is-disabled');
		}
		,setSearchConditionStationHtml: function() {
			const self = this;
			self._$searchConditionStation.eq(0).each(function() {
				self._$searchConditionStation.html(Nifty.WallPaint.JsRender.renderAreaConditions(self._$searchConditionStationBase, !self._isSearchConditionPlacesHtmlDone, true));
				Nifty.WallPaint.Pc.Animation.setAccordion();
				Nifty.WallPaint.Pc.Animation.setCheckMatch();
				Nifty.WallPaint.Pc.Animation.setFormLock();
			});
		}
		,setSearchConditionPlacesHtml: function(searchForm, isExcludeStation) {
			const self = this;
			Nifty.Utils.Data.loadAreasData(function() {
				Nifty.WallPaint.JsRender.setSearchForm(searchForm);
				self._$searchConditionCity.eq(0).each(function() {
					self._$searchConditionCity.html(Nifty.WallPaint.JsRender.renderAreaConditions(self._$searchConditionCityBase, !self._isSearchConditionPlacesHtmlDone));
					Nifty.WallPaint.Pc.Animation.setFormLock();
				});
				self._$searchConditionLine.eq(0).each(function() {
					self._$searchConditionLine.html(Nifty.WallPaint.JsRender.renderAreaConditions(self._$searchConditionLineBase, !self._isSearchConditionPlacesHtmlDone));
					Nifty.WallPaint.Pc.Animation.setFormLock();
				});
				if (!isExcludeStation) {
					self.setSearchConditionStationHtml();
				}
				if (!self._isSearchConditionPlacesHtmlDone) {
					self._isSearchConditionPlacesHtmlDone = true;
					self._$changeAreasConditionTrigger.removeClass('is-disabled');
					// 検索結果ページ用: 選択条件表示
					$(document).trigger('set-search-conditions');
				}
			});
		}

		// 共通: お気に入り件数表示
		,showBukkenFavoriteCount: function() {
			Nifty.WallPaint.Function.showBukkenFavoriteCount();
		}
	};
	Nifty.WallPaint.Pc.Function.initChangeAreasConditionTrigger();
	Nifty.WallPaint.Pc.Function.showBukkenFavoriteCount();

	// 共通: カンタン検索
	const $easySearchForm = $('[data-easy-search-form]');
	const $easySearchSuggestBase = $('[data-template-base="easy-search-suggest"]:eq(0)');
	$easySearchForm.each(function() {
		const $form = $(this);
		const $input = $form.find('[data-easy-search-input]');
		const $submit =  $form.find('button[type="submit"]');
		// Internet Explorer, Microsoft Edgeで:placeholder-shownが効かない為、代替classを付与
		const classIsPlaceholderShown = 'is-placeholder-shown';

		const searchForm = Nifty.WallPaint.SearchForm.create($form);
		const formActionUrl = $form.attr('action');
		searchForm.setEasySearchEvents($input, $submit, function() {
			const $suggest = $form.find('[data-template="easy-search-suggest"]');
			const $clear = $form.find('[data-easy-search-clear]');

			// 駅/市区町村のサジェスト追加
			const addStationAndCitySuggestData = function(data, value) {
				const hits = searchForm.getEasySearchResult(value);

				searchForm.addEasySearchSuggestData(data.suggests, '駅', hits.station);
				searchForm.addEasySearchSuggestData(data.suggests, '市区町村', hits.city);
			};

			// カンタン検索: 候補表示
			$input.on('keyup', function() {
				const value = $(this).val();
				const placeholder = $(this).attr('placeholder');
				const data = {
					suggests: []
				};
				if (value) {
					const hits = searchForm.getEasySearchResult(value);
					searchForm.addEasySearchSuggestData(data.suggests, '駅', hits.station);
					searchForm.addEasySearchSuggestData(data.suggests, '市区町村', hits.city);
					if (data.suggests.length <= 0) {
						searchForm.addEasySearchSuggestData(data.suggests, '候補が見つかりません。');
					}
				} else {
					searchForm.addEasySearchSuggestData(data.suggests, Nifty.WallPaint.Function.makeEasySearchSuggestTextIfEmpty(placeholder));
				}
				$suggest.html(Nifty.WallPaint.JsRender.render($easySearchSuggestBase, data));
			});
			// 初期設定
			$input.trigger('keyup');

			// カンタン検索: 入力クリア
			$clear.on('click', function() {
				$input.val('').trigger('keyup');
			});

			// カンタン検索: フォーカスON/OFF
			$input.on('focus', function() {
				$suggest.addClass('is-active');
			});
			$input.on('blur', function() {
				setTimeout(function() {
					// 候補選択より後に動作させる
					$suggest.removeClass('is-active');
				}, 100);
			});

			// カンタン検索: Enterキーを無効化
			$input.on('keypress', function(e) {
				if (e.key == 'Enter') {
					return false;
				}
			});
		});
	});

	// click発火制御
	$(document).on('click', '[data-trigger-click-control]', function() {
		const content = $(this).attr('data-trigger-click-control');
		$('[data-trigger-click-content="' + content + '"]:eq(0)').trigger('click');
	});

	// トグルリスト開閉
	Nifty.WallPaint.Function.setEasyToggle();

	// 相場診断フォーム
	Nifty.WallPaint.SoubaShindan.init();
	// ここまで共通関数定義 ----------------------

	// -------------------------------------------
	// 共通(全体)
	// -------------------------------------------
	// 共通: フォーム内容の同期
	Nifty.WallPaint.Function.setTextmatchSync();
	Nifty.WallPaint.Function.setSelectmatchSync();

	// 共通: ページ内スクロール
	$(document).on('click', 'a[href^="#"]', function(e) {
		e.preventDefault();

		const $scrollArea = $(this).closest('.is-overflow-y-auto');
		$($(this).attr('href')).eq(0).each(function() {
			if ($scrollArea.length > 0) {
				$scrollArea.animate({ scrollTop: $(this).position().top }, 'normal');
			} else {
				Nifty.Utils.Page.scrollTo($(this));
			}
		});
	});

	// 共通: ページトップへ戻るボタン
	const $goTop = $('#goTop');
	$goTop.eq(0).each(function() {
		$(window).on('scroll', function() {
			if ($(this).scrollTop() > 500) {
				$goTop.slideDown(100);
			} else {
				$goTop.slideUp(100);
			}
		});
		$goTop.on('click', 'button', function(e) {
			$('body,html').animate({ scrollTop: 0 }, 500);
		});
		// 下部追従コンテンツがある場合
		$('.is-fixed-bottom:not(.modal-item-box):eq(0)').each(function () {
			$goTop.css('bottom', $(this).height());
		});
	});
	// ここまで共通(全体) ------------------------

	// -------------------------------------------
	// 共通(一部)
	// -------------------------------------------
	// トップ/大エリア: 地図選択の初期タブ設定
	setTimeout(function() {
		$('#areaPrefTabMap').eq(0).each(function() {
			// デフォルトは路線選択
			const tab = (location.hash) ? location.hash.replace('#', '') : 'line';
			$(this).find('[data-tab-control="' + tab + '"]:not(.is-active)').trigger('click');
		});
	}, 200);
	// ここまで共通(一部) ------------------------

	// -------------------------------------------
	// 都道府県
	// -------------------------------------------
	const $searchPrefForm = $('form#searchPrefForm');
	$searchPrefForm.eq(0).each(function() {
		const searchForm = Nifty.WallPaint.SearchForm.create($searchPrefForm);
		const $stationSearchConditionsDefault = $('#stationSearchConditionsDefault');
		const $stationSearchConditionsArea = $('#stationSearchConditionsArea');

		// 駅選択条件をサーバ側で出力済みの場合、駅選択条件生成を除外
		Nifty.WallPaint.Pc.Function.setSearchConditionPlacesHtml(searchForm, ($stationSearchConditionsDefault.length > 0));

		// 都道府県: フォームsubmit
		$searchPrefForm.on('submit', function(e) {
			e.preventDefault();
			location.href = searchForm.makeResultUrl();
		});

		// 都道府県: 件数カウンター
		const updateCounter = function() {
			const content = searchForm.isSearchStation() ? 'station' : 'city';
			searchForm.updateResultCounter($('[data-multitab-content="' + content + '"] [data-search-result-counter]'));
		};
		$searchPrefForm.on('change', '[data-multitab-content="city"] input,[data-multitab-content="station"] input,#conditions input,#conditions select', function() {
			updateCounter();
		});

		// 都道府県: エリア選択チェックボックスリンク
		$searchPrefForm.on('click', 'a[data-submit-area-checkbox-link]', function(e) {
			e.preventDefault();

			searchForm.checkThisInputOnly($(this).closest('li').find('input[type="checkbox"]'));
			$searchPrefForm.submit();
		});
		// 都道府県: 路線→駅選択チェックボックスリンク
		$searchPrefForm.on('click', 'a[data-move-to-station-checkbox-link]', function(e) {
			e.preventDefault();
			searchForm.checkThisInputOnly($(this).closest('li').find('input[type="checkbox"]'));
			// チェックした路線の駅を絞り込むボタンの活性化
			Nifty.WallPaint.Pc.Animation.initFormLock();

			$searchPrefForm.find('[data-multitab-control="station"]:eq(0)').trigger('click');
		});

		// 都道府県: 路線選択数チェック
		$searchPrefForm.on('change', '[data-multitab-content="line"] input[type="checkbox"]', function() {
			searchForm.checkLineCondSelect($(this));
		});
		// 都道府県: 駅選択数チェック
		$searchPrefForm.on('change', '[data-multitab-content="station"] input[type="checkbox"]', function() {
			searchForm.checkStationCondSelect($(this));
		});
		// 都道府県: チェックした路線の駅を絞り込む
		$searchPrefForm.on('click', '[data-multitab-control="station"]', function() {
			Nifty.WallPaint.Pc.Function.setSearchConditionStationHtml();
			$('a[data-menutab-control="line"]').attr('data-menutab-control', 'station');

			updateCounter();
			Nifty.Utils.Page.scrollToIfUnder($searchPrefForm);
		});

		// 都道府県: 路線を再選択
		$searchPrefForm.on('click', '[data-multitab-control="line"]', function() {
			searchForm.setSearchStation(true);
			$('a[data-menutab-control="station"]').attr('data-menutab-control', 'line');

			$stationSearchConditionsDefault.remove();
			$stationSearchConditionsArea.removeClass('is-hidden');
		});

		// 都道府県: タブ切り替え
		$(document).on('click', 'a[data-menutab-control]', function(e) {
			e.preventDefault();
			const control = $(this).attr('data-menutab-control');

			searchForm.setSearchStation((control != 'city'));
			$('#conditions').attr('data-formlock-content', (searchForm.isSearchStation()) ? 'station' : 'city');
			updateCounter();
			Nifty.WallPaint.Pc.Animation.initFormLock();

			$('[data-multitab-content]').removeClass('is-active').filter('[data-multitab-content="' + control + '"]').addClass('is-active');
			$(this).addClass('is-active').siblings('a').removeClass('is-active');
		});

		// 都道府県: 駅から探す/市区町村から探すのボタン表示→タブ表示へ遷移時の処理
		$(document).on('click', '[data-change-hash]', function(e) {
			e.preventDefault();
			const value = $(this).attr("data-change-hash");
			if (value) {
				const currentUrl = new URL(window.location.href);
				currentUrl.hash = "#" + value;
				history.pushState(null, "", currentUrl.toString());

				$('a[data-menutab-control="' + value + '"]').trigger('click');
			}
		});
	});
	// ここまで都道府県 --------------------------

	// -------------------------------------------
	// 検索結果
	// -------------------------------------------
	const $searchResultForm = $('form#searchResultForm');
	$searchResultForm.eq(0).each(function() {
		const $resultAjaxAllArea = $('#resultAjaxAllArea');
		const searchForm = Nifty.WallPaint.SearchForm.create($searchResultForm);
		Nifty.WallPaint.Pc.Function.setSearchConditionPlacesHtml(searchForm);

		// 検索結果: エリア検索種別
		let prevSearchAreaType = searchForm.isSearchStation();
		const setSearchAreaType = function($item) {
			const content = $item.closest('[data-multitab-content]').attr('data-multitab-content');
			if (content == 'city' || content == 'station') {
				prevSearchAreaType = searchForm.isSearchStation();
				searchForm.setSearchStation((content == 'station'));
			}
		};
		const restoreSearchAreaType = function() {
			searchForm.setSearchStation(prevSearchAreaType);
		};
		const getSearchAreaType = function() {
			return (searchForm.isSearchStation() ? 'station' : 'city');
		};

		// 検索結果: 検索条件関連の初期処理
		const setSearchConditions = function() {
			const conditions = searchForm.getSearchConditions();
			$('[data-search-result-cond-text]').each(function() {
				// 検索条件テキスト表示
				const condTextType = $(this).attr('data-search-result-cond-text');
				const $condShowSection = $(this).closest('[data-search-result-cond]');

				const showConditions = conditions[condTextType];
				if (showConditions && showConditions.length > 0) {
					$(this).html(showConditions.join(','));
				} else if (condTextType == 'area') {
					// 路線・駅選択モーダルから駅を未選択で検索実行した場合は「すべての駅」を表示する
					// (都道府県のみによる絞り込みのため厳密にはすべての駅の検索ではないが、「変更」リンクが路線・駅の変更である事が分かるようにする為の表示)
					$(this).html((searchForm.isSearchStation()) ? 'すべての駅' : 'すべての市区町村');
				} else {
					$(this).html('-');
				}
			});
		};

		// 検索結果: 市区町村/駅の条件選択パーツを非同期で生成する為、イベントで初期化を実行する
		$(document).on('set-search-conditions', function() {
			setSearchConditions();
		});

		// 検索結果: 「選択中のエリア」更新(「変更」で開くモーダル変更、「駅を変更」などの表示/非表示切り替え)
		const updateLeftMenuMultitabTriggers = function(content) {
			const $currentMultitabTrigger = $('[data-current-multitab-trigger]');
			const $areaMultitabTrigger = $('[data-area-multitab-triggers] [data-multitab-trigger]');

			content = (content) ? content : $currentMultitabTrigger.attr('data-multitab-trigger');
			if (content == 'condition') {
				// 絞り込み条件を変更した場合は何もしない
				return;
			}
			$currentMultitabTrigger.attr('data-multitab-trigger', content);

			let showTargetContents = [];
			if (content == 'line' || content == 'station') {
				showTargetContents = [ 'city' ];
			} else if (content == 'city') {
				showTargetContents = [ 'line', 'station' ];
			}
			$areaMultitabTrigger.each(function() {
				if (showTargetContents.indexOf($(this).attr('data-multitab-trigger')) != -1) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
		};
		updateLeftMenuMultitabTriggers();

		// 検索結果: Ajax更新
		Nifty.WallPaint.History.setPopstate();
		const searchResultAjax = function(url, isAjaxAll) {
			const $resultArea = (isAjaxAll ? $resultAjaxAllArea : $('#resultAjaxArea'));
			if ($resultArea.length > 0) {
				Nifty.WallPaint.Pc.Function.setShowLoading(true);
				searchForm.getResultAjax(url, isAjaxAll, {
					success: function(res) {
						$resultArea.html(res);
						const resultCount = $('[data-search-result-count]:eq(0)').text();
						$('[data-search-result-counter]').text(resultCount ? resultCount : '0');

						if (isAjaxAll) {
							setSearchConditions();
							updateLeftMenuMultitabTriggers();
							$('[data-current-multitab-trigger]').removeClass('is-disabled');
						}
						Nifty.WallPaint.Pc.Animation.initMicroModal();
						Nifty.WallPaint.Pc.Animation.setCheckMatch();

						Nifty.Utils.History.setPrevNextState(Nifty.WallPaint.History.state.RESULT_AJAX_PREV, Nifty.WallPaint.History.state.RESULT_AJAX_NEXT, url);
					}
					,error: function() {
						// エラー時
						location.href = url;
					}
					,complete: function() {
						Nifty.WallPaint.Pc.Function.setShowLoading(false);
					}
				});
			} else {
				location.href = url;
			}
		};

		// 検索結果: フォームsubmit
		$searchResultForm.on('submit', function(e) {
			e.preventDefault();

			// エリアの条件が変更された場合のみ、近隣エリアなども更新する
			const url = searchForm.makeResultUrl();
			searchResultAjax(url, searchForm.isAjaxAllResultUrl(url));
		});

		// 検索結果: 「選択中のエリア」の「変更」クリック
		$searchResultForm.on('change', '[data-current-multitab-trigger]', function() {
			const micromodal = $(this).attr('data-micromodal-trigger');
			const multitab = $(this).attr('data-current-multitab-trigger');
			$('[data-micromodal-trigger="' + micromodal + '"][data-multitab-trigger="' + multitab + '"]:eq(0)').trigger('click');
		});

		// 検索結果: form配下以外(ソートなど)の項目変更
		$(document).on('change', '[data-search-result-change-section] input,[data-search-result-change-section] select', function() {
			$searchResultForm.submit();
		});

		// 検索結果: 「検索結果に反映」ボタンclick
		$searchResultForm.on('click', 'button[data-submit-button]', function() {
			setSearchAreaType($(this));
			updateLeftMenuMultitabTriggers($(this).closest('[data-multitab-content]').attr('data-multitab-content'));
			$searchResultForm.submit();
			Nifty.Utils.Page.scrollToIfUnder($resultAjaxAllArea);
		});

		// 検索結果: 該当リンクのチェックボックスのみチェック
		const checkOnlyThisLinkItem = function($link) {
			searchForm.checkThisInputOnly($link.closest('li').find('input[type="checkbox"]'));
			setSearchAreaType($link);
		};
		// 検索結果: エリア選択チェックボックスリンク
		$searchResultForm.on('click', 'a[data-submit-area-checkbox-link]', function(e) {
			e.preventDefault();

			checkOnlyThisLinkItem($(this));
			$('[data-micromodal-close="modal-change-conditions"]:eq(0)').trigger('click');
			updateLeftMenuMultitabTriggers($(this).closest('[data-multitab-content]').attr('data-multitab-content'));
			$searchResultForm.submit();
			Nifty.Utils.Page.scrollToIfUnder($resultAjaxAllArea);
		});
		// 検索結果: 路線→駅選択チェックボックスリンク
		$searchResultForm.on('click', 'a[data-move-to-station-checkbox-link]', function(e) {
			e.preventDefault();

			checkOnlyThisLinkItem($(this));
			// チェックした路線の駅を絞り込むボタンの活性化
			Nifty.WallPaint.Pc.Animation.initFormLock();
			$('[data-multitab-control="station"]:eq(0)').trigger('click');
		});

		// 検索結果: 路線選択数チェック
		$searchResultForm.on('change', '[data-multitab-content="line"] input[type="checkbox"]', function() {
			searchForm.checkLineCondSelect($(this));
		});
		// 検索結果: 駅選択数チェック
		$searchResultForm.on('change', '[data-multitab-content="station"] input[type="checkbox"]', function() {
			searchForm.checkStationCondSelect($(this));
		});
		// 検索結果: チェックした路線の駅を絞り込む
		$searchResultForm.on('click', 'button[data-move-to-station-button]', function() {
			Nifty.WallPaint.Pc.Function.setSearchConditionStationHtml();
		});

		// 検索結果: ページングリンクclick
		$(document).on('click', 'a[data-paging-link]', function(e) {
			e.preventDefault();
			searchResultAjax($(this).attr('href'));
			Nifty.Utils.Page.scrollToIfUnder($('#resultAjaxArea'));
		});

		// 検索結果: 条件パラメータ引継ぎリンク
		$(document).on('click', 'a[data-extends-cond-param]', function(e) {
			e.preventDefault();
			const type = $(this).attr('data-extends-cond-param');
			const url = searchForm.makeExtendsCondParamLinkUrl($(this).attr('href'));

			if (type == 'ajax') {
				searchResultAjax(url);
			} else {
				location.href = url;
			}
		});

		// 検索結果: 件数カウンター
		$searchResultForm.on('change', '[data-multitab-content] input,[data-multitab-content] select', function() {
			const $multitabContent = $(this).closest('[data-multitab-content]');
			if ($('[data-multitab-content="' + $multitabContent.attr('data-multitab-content') + '"] [data-search-result-counter]').length > 0) {
				const searchAreaType = getSearchAreaType();
				setSearchAreaType($(this));
				searchForm.updateResultCounter($('[data-search-result-counter]'));
				if (searchAreaType != getSearchAreaType()) {
					restoreSearchAreaType();
				}
			}
		});
	});

	// 検索結果: 検索条件パーツ表示制御
	$('button[data-multitab-trigger]:eq(0)').each(function() {
		const $multitabBackButton = $('button[data-multitab-back]');
		const $multitabLineStTrigger = $('button[data-multitab-trigger="line"],button[data-multitab-trigger="station"]');
		const setMultitabBackButton = function(content) {
			if ($multitabBackButton.filter('[data-multitab-control="' + content + '"]').removeClass('is-hidden').length > 0) {
				$multitabBackButton.filter('[data-multitab-control!="' + content + '"]').addClass('is-hidden');
			}
		};
		const setMultitabContentSub = function(content, sub) {
			const $multitabContentSub = $('[data-multitab-content="' + content + '"] [data-multitab-content-sub]');
			if (sub) {
				const subList = sub.split(',');
				$multitabContentSub.each(function() {
					if (subList.indexOf($(this).attr('data-multitab-content-sub')) >= 0) {
						$(this).removeClass('is-hidden').show();
					} else {
						$(this).addClass('is-hidden').hide();
					}
				});
			}
		};
		const $multitabContent = $('[data-multitab-content]');
		$(document).on('click', 'button[data-multitab-trigger]', function() {
			const content = $(this).attr('data-multitab-trigger');
			$multitabContent.filter('[data-multitab-content="' + content + '"]').addClass('is-active');
			$multitabContent.filter('[data-multitab-content!="' + content + '"]').removeClass('is-active');
			setMultitabBackButton(content);
			setMultitabContentSub(content, $(this).attr('data-multitab-control-sub'));
		});
		$(document).on('click', 'button[data-multitab-control]', function() {
			const content = $(this).attr('data-multitab-control');
			setMultitabBackButton(content);
			setMultitabContentSub(content, $(this).attr('data-multitab-control-sub'));
			if (content == 'station' || content == 'line') {
				$multitabLineStTrigger.attr('data-multitab-trigger', content);
			}
		});
	});
	// ここまで検索結果 --------------------------

	// -------------------------------------------
	// 業者詳細
	// -------------------------------------------
	$('#isShopDetail').eq(0).each(function() {
		// 業者詳細: 「他の○○を見る」で可視状態となったテキストの「続きを見る」初期化
		$(document).on('click', '[data-easy-toggle-control]', function() {
			Nifty.WallPaint.Pc.Animation.setReadmore();
		});
		// 業者詳細: 「続きを見る」を見るクリック済みのテキストが「他の○○を見る」クリックで再度初期化されないよう属性を削除
		$(document).on('click', '[data-readmore-control]', function() {
			$('[data-readmore-content="' + $(this).attr('data-readmore-control') + '"]').removeAttr('data-readmore-content data-readmore-height');
		});
	});
	// ここまで業者詳細 --------------------------
});
